export class InitiateAccountSwitchResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "redirectUrl",
            "baseName": "redirectUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InitiateAccountSwitchResponse.attributeTypeMap;
    }
    constructor() {
    }
}
